/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <div class="store_login_unit">{{brandStoreName}}</div>
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="check_List_tbl_unit wd976 tbl_ht_login_info tbl_bg_blue">
                <div  class="tbl_bg_blue" id="pageSetting" name="pageSetting" >
                    <Message v-if="validationMessage" :validationMessage="alertMessage" /><br>
                    <Message :validationMessage="validationMessage" />
                    <Message v-if="apiValidationMessage" :validationMessage="apiValidationMessage" />
                    <div class="admin_button_top_unit">
                        <div class="flex_sensor_list">
                            <div class="checkSetting_buttan_unit ">
                                <div class="checkSetting_kanri_box right_btn_csv">
                                    <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="addColum">行追加</a></li></ul>
                                </div>
                            </div>
                            <div class="right_btn_csv">
                                <a href="#" @click.prevent.stop="csvOutput">CSV出力</a>
                            </div>
                        </div>
                    </div>

                    <table class="checkSetting_tbl_unit senser_list_table" >
                        <tbody>
                            <tr class="text-center">
                                <th class="wd160">設置名称・備考</th>
                                <th class="wd90">センサーID</th>
                                <th class="wd85">温湿度・熱中症<br>アラート通知</th>
                                <th class="wd167">温湿度・熱中症アラート通知時間</th>
                                <th class="wd85">データ欠落<br>アラート通知</th>
                                <th class="wd80">データ欠落<br>継続時間</th>
                                <th class="wd167">データ欠落アラート通知時間</th>
                                <th class="wd120">種別</th>
                                <th class="wd85">最新データ</th>
                                <th class="wd50">最新<br>温度</th>
                                <th class="wd50">最新<br>湿度</th>
                                <th class="wd85">削除</th>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr v-for="(sensorsetting,index) in senserDataList" :key="sensorsetting.sensor_setting_id">
                                <td>
                                    <input type="text" class="wd150" v-model="sensorsetting.location" maxlength="20">
                                </td>
                                <td>
                                    <input type="text" class="wd75" v-model="sensorsetting.sensor_id" maxlength="11">
                                </td>
                                <td>
                                    <select v-model="sensorsetting.status" class="select_height">
                                        <option value="" disabled></option>
                                        <option :value="1" >有</option>
                                        <option :value="2" >無</option>
                                    </select>
                                </td>
                                <td>
                                    <vue-timepicker input-width="70px" v-bind:disabled="timePickerDisable(sensorsetting.status)" minute-interval="10" v-model="sensorsetting.alert_notification_from"></vue-timepicker>
                                    ～
                                    <vue-timepicker input-width="70px" v-bind:disabled="timePickerDisable(sensorsetting.status)" minute-interval="10" v-model="sensorsetting.alert_notification_to"></vue-timepicker>
                                </td>
                                <td>
                                    <select v-model="sensorsetting.missing_status" class="select_height">
                                        <option value="" disabled></option>
                                        <option :value="1" >有</option>
                                        <option :value="2" >無</option>
                                    </select>
                                </td>
                                <td>
                                    <input type="text" class="wd45" v-model="sensorsetting.duration_missing">分
                                </td>
                                <td>
                                    <vue-timepicker input-width="70px" v-bind:disabled="timePickerDisable(sensorsetting.missing_status)" minute-interval="10" v-model="sensorsetting.missing_alert_notification_from"></vue-timepicker>
                                    ～
                                    <vue-timepicker input-width="70px" v-bind:disabled="timePickerDisable(sensorsetting.missing_status)" minute-interval="10" v-model="sensorsetting.missing_alert_notification_to"></vue-timepicker>
                                </td>
                                <td>
                                    <select v-model="sensorsetting.sensor_kbn_id" class="select_height">
                                        <option value=null disabled>種別を選択</option>
                                        <option v-for="sensorkbnsetting in sensorkbnsettings" :key="sensorkbnsetting.sensorKbnId" :value="sensorkbnsetting.sensorKbnId" >
                                            {{sensorkbnsetting.sensorKbnName}}</option>
                                    </select>
                                </td>
                                <td class="text_white_space">{{sensorsetting.detectiondatetime}}</td>
                                <td>{{sensorsetting.temperature}}</td>
                                <td>{{sensorsetting.humidity}}</td>
                                <td>
                                    <div class="checkSetting_kanri_box ">
                                        <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="deleteinfo(index,sensorsetting.sensor_setting_id,sensorsetting.location,sensorsetting.sensor_id)">
                                            削除</a></li></ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div>
                <div class="btn_submit" style="text-align: center">
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li>
                            <router-link class="checkSetting_buttan_unit" :to="{ name: 'managemenu'} ">キャンセル</router-link>
                        </li>
                    </ul>
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit" href="#" @click.prevent.stop="sendSenser">更新</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">センサー情報一覧</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>センサー情報一覧の更新が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent2">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">センサー削除</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>このセンサー情報を削除しますか？<br>
                            設置名称・備考：{{this.senserLocationDes}}<br>
                            センサーID：{{this.senserIdDes}}
                        </p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.prevent.stop="deleteinfoClose">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="delecSelect">削除</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent3">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">センサー情報</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>センサー情報削除が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="deleteResulteClose">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent4">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">CSV出力</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>CSV出力が完了しました。</p>
                    </div>
                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeCsvModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>

</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'
export default {
    name: 'SenserList',
    components: {
        PulseLoader,
        Message,
        VueTimepicker
    },
    data: function () {
        return {
            isLoading:false,
            isInitLoading:true,
            validationMessage:'',
            alertMessage:'入力エラーがあります。',
            showContent:false,
            showContent2:false,
            showContent3:false,
            showContent4:false,
            senserIdDes:'',
            senserLocationDes:'',
            sensorSettingIdDes:null,
            selectSenserIndex:null,
            senserDataList:[
                {sensor_setting_id:null,location:'',sensor_id:'',status:null,sensor_kbn_id:null,detectiondatetime:'',temperature:null,humidity:null,alert_notification_from:'',alert_notification_to:'',duration_missing:0,missing_status:null,missing_alert_notification_from:'',missing_alert_notification_to:''}
            ],
            "sensorsettings": [
            ],
            "sensorkbnsettings": [],
            apiValidationMessage: "",
            csvResponseData: [],
        }
    },
    computed:{
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        brandStoreName: function () {
            let brandName = this.$store.getters['brand/name']
            let storeName = this.$store.getters['store/name']

            if (brandName == null) {
                brandName = ''
            }

            if (storeName == null) {
                storeName = ''
            }

            return brandName + '・' + storeName
        },
    },
    created: function(){
        this.calc();
    },
    methods:{
        async calc(){

            // 機器設定一覧取得API
            var brandId = this.$store.getters['brand/id'];
            var storeId = this.$store.getters['store/id'];
            var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/store/' + storeId + '/measuring_instruments/setting';

            // API処理判定
            var apiResponseFlg = true;
            await this.$axios
                .get(url)
                .then(response => (this.sensorsettings = response.data.sensorSetting,this.sensorkbnsettings = response.data.sensorKbnSettings))
                .catch((err)=> {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}

                    if (err.customError.code == 401) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                    }
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);

            // API処理判定
            if(!apiResponseFlg){
                return null;
            }

            //データの詰め替え
            let itemList = [];
            //ヘッダーのID設定を追加
            for(var k = 0 ; k < this.sensorsettings.length ; k++){
                var inpuotApiDataObj = new Object();

                inpuotApiDataObj['status'] = this.sensorsettings[k].status;
                inpuotApiDataObj['sensor_setting_id'] = this.sensorsettings[k].sensorSettingId;
                inpuotApiDataObj['location'] = this.sensorsettings[k].location;
                inpuotApiDataObj['sensor_id'] = this.sensorsettings[k].sensorId;
                inpuotApiDataObj['sensor_kbn_id'] = this.sensorsettings[k].sensorKbnId;
                inpuotApiDataObj['detectiondatetime'] = this.sensorsettings[k].detectionDatetime;
                inpuotApiDataObj['temperature'] = this.sensorsettings[k].temperature;
                inpuotApiDataObj['humidity'] = this.sensorsettings[k].humidity;
                inpuotApiDataObj['alert_notification_from'] = this.sensorsettings[k].alertNotificationFrom;
                inpuotApiDataObj['alert_notification_to'] = this.sensorsettings[k].alertNotificationTo;
                inpuotApiDataObj['duration_missing'] = this.sensorsettings[k].durationMissing;
                inpuotApiDataObj['missing_status'] = this.sensorsettings[k].missingStatus;
                inpuotApiDataObj['missing_alert_notification_from'] = this.sensorsettings[k].missingAlertNotificationFrom;
                inpuotApiDataObj['missing_alert_notification_to'] = this.sensorsettings[k].missingAlertNotificationTo;

                itemList.push(inpuotApiDataObj);
            }
            this.senserDataList = itemList;

        },
        addColum(){
            let senserDataList = [];
            senserDataList = this.senserDataList;
            var addObj = {sensor_setting_id:null,location:'',sensor_id:null,status:null,sensor_kbn_id:null,detectiondatetime:'',temperature:null,humidity:null,alert_notification_from:'00:00',alert_notification_to:'00:00',duration_missing:0,missing_status:null,missing_alert_notification_from:'00:00',missing_alert_notification_to:'00:00'};

            senserDataList.push(addObj)
            this.senserDataList = senserDataList;
        },
        deleteinfo(index,sensorSettingId,location,sensorid){
            this.selectSenserIndex = index;
            this.senserIdDes = sensorid;
            this.senserLocationDes = location;
            this.sensorSettingIdDes = sensorSettingId;
            this.showContent2 = true;
        },
        deleteinfoClose(){
            this.selectSenserIndex = null;
            this.senserIdDes = '';
            this.senserLocationDes = '';
            this.sensorSettingIdDes = null;
            this.showContent2 = false;
        },
        deleteResulteClose(){
            this.selectSenserIndex = null;
            this.senserIdDes = '';
            this.senserLocationDes = '';
            this.sensorSettingIdDes = null;
            this.showContent3 = false;
        },
        async delecSelect(){

            // 確認ダイアログをClose
            this.showContent2 = false;

            this.isLoading = true;
            var apiResponseFlg = true;
            this.validationMessage = '';

            var senserDataList = this.senserDataList;

            // 新規追加レコードを判定し、対象の場合は内部データのみ削除する。
            if(!this.senserDataList[this.selectSenserIndex].sensor_setting_id == '' ||
                !this.senserDataList[this.selectSenserIndex].sensor_setting_id == null ){

                // 機器設定情報削除API
                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/id'];
                var sensorSettingId = this.sensorSettingIdDes;
                var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/store/' + storeId + '/measuring_instruments/setting/' + sensorSettingId  + '/delete';

                // 機器設定情報削除API呼び出し
                await this.$axios
                    .post(url)
                    .then()
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.validationMessage =  error.message;
                                this.scrollTop();
                            } else if (error.code == 401) {
                                //店舗管理者のtokenエラーの場合
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    });

                // 処理エラーがない場合
                if(apiResponseFlg){
                    this.showContent3 = true;
                    // 内部データの削除
                    senserDataList.splice(this.selectSenserIndex,1);
                }
            }else {
                // 内部データの削除
                senserDataList.splice(this.selectSenserIndex,1);
            }
            this.senserDataList = senserDataList;
            this.isLoading = false;
        },
        async sendSenser(){

            var addFormFlg = true;
            var apiResponseFlg = true;
            this.isLoading = true;
            this.validationMessage = '';

            //エラー内容初期化
            this.clearError();

            let senserDataList = [];
            senserDataList = this.senserDataList;

            // 必須チェック
            for(var L = 0 ; L < senserDataList.length ; L++) {
                if(!senserDataList[L].sensor_id){
                    addFormFlg = false
                    this.validationMessage = 'センサーIDを入力してください。';
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
            }

            //文字種
            for(var k = 0 ; k < senserDataList.length ; k++) {
                if(!this.chechStrong(senserDataList[k].sensor_id)){
                    addFormFlg = false
                    this.validationMessage = 'センサーIDは、[0~9]の文字列を[2桁]-[8桁]の形式で入力してください。';
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }

                if(senserDataList[k].duration_missing != "" && !this.checkInteger(senserDataList[k].duration_missing)){
                    addFormFlg = false
                    this.validationMessage = 'データ欠落継続時間は、半角数字を入力してください。';
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
            }

            //桁数チェック
            for(var p = 0 ; p < senserDataList.length ; p++) {
                if(String(senserDataList[p].sensor_id).length !== 11){
                    this.validationMessage = "センサーIDは11桁で入力してください。";
                    addFormFlg = false;
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
            }

            // 重複チェック
            // 入力内容で繰り返し
            for(var h = 0 ; h < senserDataList.length ; h++) {
                // 次行がある場合の処理
                if ((h + 1) !== senserDataList.length) {
                    // 比較元のデータを取得
                    var inpuotApiDataObj = senserDataList[h];

                    for (var i = h+1; i < senserDataList.length; i++) {
                        if (inpuotApiDataObj.location == senserDataList[i].location) {
                            addFormFlg = false;
                            this.isLoading = false;
                            this.validationMessage = '設置名称・備考は既に登録されています'
                            this.scrollTop();
                            return null;
                        }
                        if (inpuotApiDataObj.sensor_id == senserDataList[i].sensor_id) {
                            addFormFlg = false;
                            this.isLoading = false;
                            this.validationMessage = 'センサーIDは既に登録されています'
                            this.scrollTop();
                            return null;
                        }
                    }
                }
            }

            // バリデーション
            if(!addFormFlg){
                this.isLoading = false;
                return null;
            }

            //正常時、API呼び出し
            if(addFormFlg){

                // 機器設定一覧更新APIの呼び出し
                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/id'];
                var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/store/' + storeId + '/measuring_instruments/setting';

                // 不要データの削除
                //データの詰め替え
                let requestItemList = [];
                //ヘッダーのID設定を追加
                for(var requestCount = 0 ; requestCount < this.senserDataList.length ; requestCount++){
                    var requestApiDataObj = new Object();

                    if(this.senserDataList[requestCount].alert_notification_from === this.senserDataList[requestCount].alert_notification_to){
                        this.senserDataList[requestCount].alert_notification_from = '00:00';
                        this.senserDataList[requestCount].alert_notification_to = '00:00';
                    }

                    if(this.senserDataList[requestCount].missing_alert_notification_from === this.senserDataList[requestCount].missing_alert_notification_to){
                        this.senserDataList[requestCount].missing_alert_notification_from = '00:00';
                        this.senserDataList[requestCount].missing_alert_notification_to = '00:00';
                    }

                    if(this.senserDataList[requestCount].duration_missing === 0){
                        this.senserDataList[requestCount].duration_missing = '0';
                    }

                    requestApiDataObj['status'] = this.senserDataList[requestCount].status;
                    requestApiDataObj['sensor_setting_id'] = this.senserDataList[requestCount].sensor_setting_id;
                    requestApiDataObj['location'] = this.senserDataList[requestCount].location;
                    requestApiDataObj['sensor_id'] = this.senserDataList[requestCount].sensor_id;
                    requestApiDataObj['sensor_kbn_id'] = this.senserDataList[requestCount].sensor_kbn_id;
                    requestApiDataObj['alert_notification_from'] = this.senserDataList[requestCount].alert_notification_from;
                    requestApiDataObj['alert_notification_to'] = this.senserDataList[requestCount].alert_notification_to;
                    requestApiDataObj['duration_missing'] = this.senserDataList[requestCount].duration_missing;
                    requestApiDataObj['missing_status'] = this.senserDataList[requestCount].missing_status;
                    requestApiDataObj['missing_alert_notification_from'] = this.senserDataList[requestCount].missing_alert_notification_from;
                    requestApiDataObj['missing_alert_notification_to'] = this.senserDataList[requestCount].missing_alert_notification_to;
                    requestItemList.push(requestApiDataObj);
                }

                //更新API呼び出し
                await this.$axios
                    .post(url, {sensor_settings:requestItemList})
                    .then()
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.validationMessage =  error.message;
                                this.scrollTop();
                            } else if(error.code == 401){
                                //店舗管理者のtokenエラーの場合
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                // 処理エラーがない場合
                if(apiResponseFlg){
                    this.showContent = true;
                }
            }

        },
        //センサー設定一覧CSVファイル出力
        async csvOutput() {
            this.isLoading = true;
            this.apiValidationMessage = '';
            let brandId = this.$store.getters['brand/id'];
            let storeId = this.$store.getters['store/id'];
            await this.$axios
                .get(this.$apiEndpoint + 'manage/measuring_instruments/setting/history/csv', {params: {brand_id: brandId, store_id: storeId}})
                .then(response => (this.csvResponseData = response))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.validationMessage =  error.message;
                            this.scrollTop();
                        } else if (error.code == 401) {
                            //店舗管理者のtokenエラーの場合
                            this.$cookies.set('user-api-token', '', 0)
                            this.$store.dispatch('store/doClear')
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);
            if(!this.commonDownloadCSV(this.csvResponseData)){
                this.apiValidationMessage =  "CSVの出力に失敗しました。";
                this.scrollTop();
            }
            else{
                this.showContent4 = true;
            }
        },
        closeCsvModel: function(){
            this.showContent4 = false;
        },
        clearError:function(){
            //メッセージ初期化
            this.validationMessage = "";
        },
        //半角英数字のチェック(文字はa~fまで)
        chechStrong:function(inputdata){
            var re = new RegExp(/^[0-9]{2}-[0-9]{8}$/);
            return re.test(inputdata);
        },
        //半角数字のチェック
        checkInteger:function(inputdata){
            var re = new RegExp(/^[0-9]+$/);
            return re.test(inputdata);
        },
        closeModel() {
            this.showContent = false;
            this.$router.push({name: 'managemenu', params: {brandId: this.userButtanId}});
        },
        timePickerDisable(value){
            if(value === 1){
                return false
            }else{
                return true
            }
        },
        scrollTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>